import apiClient from "../../../service/apiClient";
import { PORTFOLIOATTRIBUTION_ENDPOINTS } from "../../../app/apiEndpoints";

export const getPortfolioGroupTreeData = async (contactId = 0) => {
  const { data } = await apiClient.get(PORTFOLIOATTRIBUTION_ENDPOINTS.GET_PORTFOLIO_GROUP_TREE_DATA, {
    params: { contactId },
  });
  return data ?? [];
};

export const getPortfolioByClientStatement = async (clientStatementId) => {
  const { data } = await apiClient.get(PORTFOLIOATTRIBUTION_ENDPOINTS.GET_PORTFOLIO_BY_CLIENT_STATEMENT, {
    params: { ClientStatementId: clientStatementId },
  });
  return data ?? [];
};

export const getPortfolioAttributionUIData = async ({
  runStats,
  hideZero,
  viewId,
  grouping,
  reportClassificationId,
  endDate,
}) => {
  const { data } = await apiClient.post(
    PORTFOLIOATTRIBUTION_ENDPOINTS.GET_PORTFOLIO_ATTRIBUTION_UI_DATA,
    runStats,
    {
    params: {
      hideZero,
      viewId,
      grouping,
      ReportClassificationId: reportClassificationId,
      EndDate: endDate,
    },
  }
  );
  return data;
};

export const getViews = async () => {
  const { data } = await apiClient.get(PORTFOLIOATTRIBUTION_ENDPOINTS.GET_VIEWS);
  return data ?? [];
};

export const getReportClassifications = async () => {
  const { data } = await apiClient.get(PORTFOLIOATTRIBUTION_ENDPOINTS.GET_REPORT_CLASSIFICATIONS);
  return data ?? [];
};

export const exportTimeSeries = async (payload, reportClassificationId = 0) => {
  const { data } = await apiClient.post(PORTFOLIOATTRIBUTION_ENDPOINTS.EXPORT_TIME_SERIES, payload, {
    params: { reportClassificationId },
  });
  return data ?? [];
};

export const getPortfolioDocumentMapping = async (portfolioIdLst, reportDate) => {
  const { data } = await apiClient.get(PORTFOLIOATTRIBUTION_ENDPOINTS.GET_PORTFOLIO_DOCUMENT_MAPPING, {
    params: { portfolioIdLst, reportDate },
  });
  return data ?? [];
};

export const getDocumentById = (documentId) =>
  apiClient.get(`${PORTFOLIOATTRIBUTION_ENDPOINTS.GET_PORTFOLIO_DOCUMENT_BYID}/${documentId}`);

